import React from "react";
import Modal from "react-modal";

const variants = {
  success: {
    icon: "✓",
    color: "#24ff00",
    bg: "rgba(36, 255, 0, 0.12)",
    label: "Éxito",
  },
  error: {
    icon: "✕",
    color: "#ff5a5a",
    bg: "rgba(255, 90, 90, 0.12)",
    label: "Error",
  },
  info: {
    icon: "i",
    color: "#5fb3ff",
    bg: "rgba(95, 179, 255, 0.12)",
    label: "Aviso",
  },
  warning: {
    icon: "!",
    color: "#ffb949",
    bg: "rgba(255, 185, 73, 0.12)",
    label: "Atención",
  },
};

export default function AlertModal({ open, variant = "info", title, message, onClose, buttonText = "OK" }) {
  if (!open) return null;
  const v = variants[variant] || variants.info;

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
      style={{
        overlay: {
          position: "fixed",
          inset: 0,
          background: "rgba(0, 0, 0, 0.72)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          zIndex: 10500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          position: "relative",
          inset: "auto",
          margin: "0 1rem",
          padding: 0,
          border: 0,
          background: "transparent",
          maxWidth: "min(92vw, 460px)",
          width: "100%",
          overflow: "visible",
        },
      }}
    >
      <div className="fa-alert">
        <div
          className="fa-alert-icon"
          style={{ background: v.bg, color: v.color, borderColor: v.color }}
        >
          {v.icon}
        </div>
        {title && <h3 className="fa-alert-title">{title}</h3>}
        {title && <span className="fa-alert-variant">{v.label}</span>}
        <p className="fa-alert-message">{message}</p>
        <button type="button" className="fa-alert-btn" onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </Modal>
  );
}